// extracted by mini-css-extract-plugin
export default {"ritualIcon":"styles_ritualIcon__FzUfW","svg":"styles_svg__sB7Is"};